import "./Toolkit.module.css";
import Header from "@/reusable_sections/Header";
import EssentialResources from "./sections/EssentialResources";
import ShopOurFavorites from "./sections/ShopOurFavorites";
import SiteFooter from "@/reusable_sections/Footer";
export default function ToolkitPage() {
  return <div>
      <Header />
      <EssentialResources />
      <ShopOurFavorites />
      <SiteFooter />
    </div>;
}